import { useCallback, useEffect, useState } from "react";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import EbayListingsTable from "../../components/ebayListings/EbayListingsTable";
import { ListedTableStats } from "../../components/ebayListings/listedTable/Stats/ListedTableStats";



export default function EbayListings() {
  const { setInfo } = usePageNameContext();

  const [selectedMissingFields, setSelectedMissingFields] = useState<string[]>([]);

  const toggleMissingField = useCallback((key: string) => {
    setSelectedMissingFields((prev) =>
      prev.includes(key) ? prev.filter((f) => f !== key) : [...prev, key]
    );
  }, []);

  useEffect(() => {
    setInfo({
      name: "eBay Listings",
      desc: "View and manage parts that are listed on eBay",
    });
  }, []);

  return (
    <div className="flex flex-col gap-4 mt-4">
      <ListedTableStats
        selectedMissingFields={selectedMissingFields}
        onToggleMissingField={toggleMissingField}
      />
      <EbayListingsTable
        selectedMissingFields={selectedMissingFields}
        onToggleMissingField={toggleMissingField}
      />
    </div>
  );
}
